<template>
	<div>
		<h3>客户保障查询</h3>
		<div class="searchBox">
			<el-form :inline="true" :model="formInline" class="demo-form-inline">
				<el-form-item label="销售时间">
					<el-date-picker
						v-model="formInline.time"
						type="daterange"
						value-format="timestamp"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="结算状态">
					<el-select v-model="formInline.status" placeholder="结算状态">
						<el-option label="全部" value=""></el-option>
						<el-option label="未结算" value="2"></el-option>
						<el-option label="已结算" value="1"></el-option>
					</el-select>
				</el-form-item>
        	<!-- <el-form-item label="付款类型">
					<el-select v-model="formInline.status" placeholder="付款类型">
						<el-option label="全部" value=""></el-option>
						<el-option label="未结算" value="2"></el-option>
						<el-option label="已结算" value="1"></el-option>
					</el-select>
				</el-form-item> -->
        	<el-form-item label="销售渠道">
					<el-select v-model="formInline.subChannel" clearable placeholder="销售渠道">
						<el-option v-for='(item,index) in listchannel' :label="item.name" :value="item.id" :key='index'></el-option>
					</el-select>
				
				</el-form-item>
        <el-form-item label="付款方式">
					<el-select v-model="formInline.payType" clearable placeholder="付款方式">
						<el-option v-for="item in optionsPayType" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				
				</el-form-item>
        <div style="margin-bottom:20px">
           	<el-button class="text2 " type="primary" @click='getData()'>搜索</el-button>
          	<el-button class="text2 " type="primary" @click='exportsee'>导出</el-button>
        </div>
			
			</el-form>
		</div>
		<div class="table">
			<el-table :data="tableData" style="width: 100%" height='calc(100vh - 300px)'>
				<el-table-column prop="bill.id" label="ID" width='80px'></el-table-column>
				<el-table-column label="出单时间" width='180px'>
					<template slot-scope="scope">{{ setTime(scope.row.bill.createAt) }}</template>
				</el-table-column>
            	<el-table-column prop="detailsname" label="姓名" width="200"></el-table-column>
				<el-table-column prop="product.name" label="商品" width="150"></el-table-column>
				<el-table-column prop="detailCount" label="数量" align='center' width="100"></el-table-column>
				<el-table-column  label="订单号" align='center' width="160">
				<template slot-scope="scope">
								<span>{{scope.row.bill.billingNo}}</span>
							</template>
				</el-table-column>
				<el-table-column prop="channel.name" label="渠道"></el-table-column>
		  <!-- <el-table-column prop="channel.name" label="付款类型"></el-table-column> -->
				<el-table-column label="付款金额">
					<template slot-scope="scope">
						<span class="yellow">￥{{scope.row.bill.realAmount/100}}元</span>
					</template>
				</el-table-column>
               <el-table-column label="支付方式">
					<template slot-scope="scope">
					<span v-if="scope.row.channel == '' || scope.row.channel == null || scope.row.channel == undefined">{{payTypeFun(scope.row.bill.payType,3)}}</span>
					<span v-else>
					<span v-if="scope.row.channel.category">{{payTypeFun(scope.row.bill.payType,scope.row.channel.category)}}</span>
					<span v-else>{{payTypeFun(scope.row.bill.payType,3)}}</span>
					</span>
					</template>
				</el-table-column>
				<el-table-column label="状态">
					<template slot-scope="scope">
						<span class="yellow">{{ billingState[scope.row.bill.billingState] }}</span>
					</template>
				</el-table-column>
			 	<el-table-column label="操作" align="center" width="220">
					<template slot-scope="scope">
						<router-link class="blue" :to="{path:'/shop/order/orderDetails',query:{id:scope.row.bill.id}}">查看详情</router-link>
						<span v-if="scope.row.bill.orderType != 3">
							<el-button v-if='scope.row.bill.billingState == 0 || scope.row.bill.billingState == 4' type='text' disabled>退单</el-button>
					    	<el-button v-else type='text' @click='centerDialogVisible=true;exitData=scope.row'>退单</el-button>
            <!-- <el-button type="text" @click='downPdf(scope.row.bill.id)'>凭证下载</el-button> -->
						</span>
						
        
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="fenye">
			<pages class='pagination' :allpage='allpage' :changePage='changePage'></pages>
		</div>
		<el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center>
			<span>请确认退单？</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="sureExit">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="友情提示" :visible.sync="centerDialogVisible1" width="30%" center>
        <template v-for="(item,index) in exitData.invoices" >
          <refundDialog :key="index" :fpdm="item.fpdm" :fphm="item.fphm" :prodectName="exitData.product.name" />
        </template>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="centerDialogVisible1 = false">确 定</el-button>
				</span>
			</el-dialog>
	</div>
</template>

<script>
	import { orderexportOrderList,listDd, refund,downloadPdf,listchannel } from '@/axios/api.js'
	import common from '@/assets/common.js'
	import Clipboard from 'clipboard';
	import { Loading } from 'element-ui';
	import axios from 'axios'
    import refundDialog from '@/components/refundDialog'
	export default {
		data() {
			return {
                listchannel:[],
				searchText: '',
				tableData: [],
				tableData4: [],
				formInline: {
					time: null,
					status: '',
					subChannel:'',
					payType:''
				},
            	optionsPayType: [{
					value: '1',
					label: '支付宝'
				}, 
				{
					value: '2',
					label: '微信'
				},
				{
					value: '3',
					label: '线下'
				},
				{
					value: '11',
					label: '预存支付'
				}],
				allpage: 0, //数据总数
				centerDialogVisible: false,
				centerDialogVisible1:false,
				exitData: {},
				billingState: ['创建', '线上支付完成', '挂帐月结-未付', '线下转账-已付款', '已退单', '投保失败退单']
			}
		},
     
    components:{
      refundDialog
    },
		methods: {
            payTypeFun(str,channel){
				return common.payType(str,channel)
			},
			changePage(start,count){
				this.getData(start,count)
			},
			setTime(str) {
				return common.time(str)
			},
			getData(start,count) {
				var start=start || 0;//当前页
				var count=count || 10;//每页多少个
				var startts = '';
				var endts = '';
				if (this.formInline.time && this.formInline.time.length === 2) {
					startts = this.formInline.time[0];
					if(this.formInline.time[0] == this.formInline.time[1]) {
						endts = this.formInline.time[1] + 86399000;
					} else {
						endts = this.formInline.time[1];
					}
				}
				var data = {}
				if(this.formInline.subChannel != '') {
					data = {
						start,
						count,
						startts: startts,
						endts: endts,
						payType:this.formInline.payType,
						subChannel:this.formInline.subChannel,
						state: this.formInline.status
					}
				}else {
					data = {
						start,
						count,
						startts: startts,
						endts: endts,
						payType:this.formInline.payType,
						state: this.formInline.status
					}
				}
				listDd(data).then(res => {
                    this.tableData = res.data.obj;       
					for( var i = 0; i<this.tableData.length; i++) {
						if(this.tableData[i].product.productGroup == 'G67') {
							this.tableData[i].detailsname = this.tableData[i].details[0].name
						}else {
							var str = ''
						for(var j = 0; j<this.tableData[i].details.length; j++) {
							str += this.tableData[i].details[j].name + ','
						}
						var str1 = str.substr(0, str.length - 1);
						this.tableData[i].detailsname = str1
					    }
                    }
                     this.allpage = res.data.total;
					})
					.catch(err => {
						console.log(err)
					})
					var datalist = {
						start:'0',
						count:10000,
						startts: data.startts,
						endts: data.endts,
						state:this.formInline.status
					}
            	listchannel(datalist).then( res => {
					if(res.data.code == 0){
						this.listchannel=res.data.obj;
					}
				})
				.catch(err => {
					console.log(err)
				})
			},
			exportsee() {
				var token=JSON.parse(window.localStorage.getItem("token")).data.obj.token
				var startts = '';
				var endts = '';
				if (this.formInline.time && this.formInline.time.length === 2) {
					startts = this.formInline.time[0];
					if(this.formInline.time[0] == this.formInline.time[1]) {
						endts = this.formInline.time[1] + 86399000;
					} else {
						endts = this.formInline.time[1];
					}
				}
				var params = `token=${token}&subChannel=${this.formInline.subChannel}&state=${this.formInline.status}`;
				if (startts) {
					params += `&startts=${startts}&endts=${endts}`;
				}
				window.location =`${SEVERS}rescue_sale/order/exportOrderList?${params}`
			},
			sureExit() { //退单
				var data = {
					billId: this.exitData.bill.id
				}
				refund(data)
					.then(res => {
						if (res.data.code == 0) {
							this.$message({
								message: '退单成功！',
								type: 'success'
							})
							this.getData()
                       this.centerDialogVisible1=true
						} else if (res.data.code == 105009) {
							this.$message.error('保障卡已激活不能退款！')
						} else if (res.data.code == 105014) {
							this.$message.error('退单失败！')
						} else if (res.data.code == 105015) {
							this.$message.error('部分退单失败！')
						}else if (res.data.code == 105042) {
                        this.$message.error('部分退单失败！')
                        }
						this.centerDialogVisible = false;
					})
					.catch(err => {
						console.log(err)
					})
			},
			changePage(size,each){
				this.getData(size,each)
			},
      downPdf(id){
        var loadingInstance = Loading.service({ fullscreen: true })
        const httpAxios = axios.create();//创建实例
        httpAxios.defaults.timeout = 1000 * 60 * 2;
        httpAxios.get(SEVERS + '1.0/rescue_sale/sale/download_pdf',{
          params:{
            token:JSON.parse(window.localStorage.getItem("token")).data.obj.token,
            id
          }
        })
        .then(res => {
          console.log(res);
          if(res.data.code == 0){
            loadingInstance.close();
            window.location=res.data.obj
          }
        })
        .catch(err => {
          console.log(err);
          loadingInstance.close();
        })
      }
		},
    created() {

    },
		mounted() {
      this.getData();
		}
	}
</script>
<style>
	.has-gutter th {
		background-color: #f5f7fb;
	}
</style>
<style scoped="scoped">
	h3 {
		color: #333;
		font-weight: normal;
		margin-bottom: 20px;
		margin-top: 20px;
	}

	.searchBox {
		margin-top: 20px;
	}

	.input {
		width: 400px;
	}
</style>



// WEBPACK FOOTER //
// src/views/shop/order.vue